// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_p2S23dbM","highlight-text":"highlight-text_lvPQbhW8"};